import StockoutProductPanel from './stockoutProductPanel.container';

export default StockoutProductPanel;